import { Component } from '@angular/core';
import { ContactComponent } from '../contact/contact.component';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-footer', 
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  currentYear: number;

  constructor() {
    this.currentYear = new Date().getFullYear();
  }
}
